import { z } from 'zod';
import { request, useQuery } from '@applyboard/ui-utils';

const GET_RBC_RATE_URL = '/api/gic/rbc/rate';

export function useGetRbcGicRate() {
  const { isFetching, error, data } = useQuery(
    ['rbcRate'],
    async (): Promise<RbcRateResponseBody> => {
      const response = await request(GET_RBC_RATE_URL, {
        schema: rbcRateResponseBody,
      });
      const stringRate = response?.rate;
      return {
        rate: stringRate ? stringRate : undefined,
      };
    },
  );

  return {
    isFetching: isFetching,
    hasError: error,
    data: data,
  };
}

export type RbcRateResponseBody = z.infer<typeof rbcRateResponseBody>;
const rbcRateResponseBody = z.object({
  rate: z.string().nullish(),
});
